import { Autocomplete, TextField } from '@mui/material';
import { currentOrgVar } from 'apollo/reactive-variables/organization';
import { Steps } from 'models/workflow-step';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';

type StepDropdownProps = {
    stepId: string;
    onStepChange: (id: string) => void;
};

export const StepDropdown: FC<StepDropdownProps> = ({ stepId, onStepChange }) => {
    const { t: translate } = useTranslation(['common']);

    const currentOrganization = currentOrgVar();
    const steps: Steps[] = currentOrganization.workFlow?.steps?.map((step: Steps, index: number) => {
        return { ...step, index: index + 1 };
    });

    return (
        <Autocomplete
            id="step-dropdown"
            options={steps}
            onChange={(_: React.SyntheticEvent, selectedStep: Steps | null) => {
                if (selectedStep?._id) {
                    onStepChange(selectedStep?._id as string);
                    return;
                }
                onStepChange('ALL');
            }}
            value={stepId ? steps.find((step) => step._id === stepId) || null : null}
            getOptionLabel={(option: Steps) => `${option.index + ' - ' || ''}${option?.name || ''}`}
            renderOption={(props, option: Steps) => (
                <li {...{ ...props, key: option?._id }}>
                    {option.index + ' - ' || ''}
                    {option?.name || ''}
                </li>
            )}
            isOptionEqualToValue={(option: Steps, value: Steps) => option?._id === value?._id}
            renderInput={(params) => <TextField {...params} label={translate('common:STEP')} fullWidth={true} />}
        />
    );
};
